import * as React from "react";
const SvgHomefilledinline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 20.5v-6h4v6h5v-8h3l-10-9-10 9h3v8h5z", fill: "currentColor" }));
export default SvgHomefilledinline;
